var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useRef } from "react";
import { select, scaleLinear, scaleSymlog, axisBottom, axisRight } from "d3";
import { color } from "d3-color";
import { range } from "d3";
import { d3ColorScales } from "../Utils/d3ColorScale";
import { RGBToHex, colorsArray, getTickValues, } from "../Utils/legendCommonFunction";
import defaultColorTables from "../color-tables.json";
import { DEFAULT_STYLE } from "./constants";
export var ContinuousLegend = function (_a) {
    var min = _a.min, max = _a.max, dataObjectName = _a.dataObjectName, _b = _a.colorName, colorName = _b === void 0 ? "Rainbow" : _b, horizontal = _a.horizontal, getColorScaleData = _a.getColorScaleData, id = _a.id, _c = _a.colorTables, colorTables = _c === void 0 ? defaultColorTables : _c, colorMapFunction = _a.colorMapFunction, _d = _a.reverseRange, reverseRange = _d === void 0 ? false : _d, breakPoint = _a.breakPoint, editedBreakPointValues = _a.editedBreakPointValues, isLog = _a.isLog, isNearest = _a.isNearest, _e = _a.isRangeShown, isRangeShown = _e === void 0 ? true : _e, _f = _a.legendFontSize, legendFontSize = _f === void 0 ? 18 : _f, _g = _a.tickFontSize, tickFontSize = _g === void 0 ? 12 : _g, _h = _a.numberOfTicks, numberOfTicks = _h === void 0 ? 3 : _h, _j = _a.legendScaleSize, legendScaleSize = _j === void 0 ? 200 : _j, _k = _a.cssLegendStyles, cssLegendStyles = _k === void 0 ? DEFAULT_STYLE : _k;
    var generateUniqueId = Math.ceil(Math.random() * 9999).toString();
    var divRef = useRef(null);
    React.useEffect(function () {
        if (divRef.current) {
            select(divRef.current).select("div").remove();
            select(divRef.current).select("svg").remove();
            continuousLegend();
        }
        function continuousLegend() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var itemColor, parsedColorTables, res, legendColors, nearestData_1, isD3Colors, arrayData_1, d3ColorArrays_1, data, getColorTableScale_1, maxValue_1, nColors, delta_1, leftEnd_1, rightEnd_1, rgbValue, i, value, arrOfNum, userDefinedDomain_1, options, svgLegend, defs, currentIndex, linearGradient, colorScale_1, xLeg, yLeg, horizontalAxisLeg, VerticalAxisLeg, error_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            itemColor = [];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 5, , 6]);
                            if (!(typeof colorTables === "string")) return [3 /*break*/, 4];
                            return [4 /*yield*/, fetch(colorTables)];
                        case 2:
                            res = _c.sent();
                            return [4 /*yield*/, res.json()];
                        case 3:
                            parsedColorTables = _c.sent();
                            _c.label = 4;
                        case 4:
                            legendColors = typeof colorTables === "string"
                                ? colorsArray(colorName, parsedColorTables)
                                : colorsArray(colorName, colorTables);
                            nearestData_1 = [];
                            // Update color of legend based on color selector scales
                            // data is passed on click upon color scales
                            if (getColorScaleData && Object.keys(getColorScaleData).length > 0) {
                                // legend using color table data
                                if (getColorScaleData.color) {
                                    legendColors = getColorScaleData.color;
                                }
                                // legend using d3 data
                                else if (getColorScaleData.arrayData) {
                                    legendColors = getColorScaleData.arrayData;
                                }
                            }
                            isD3Colors = d3ColorScales.find(function (value) {
                                return (value === null || value === void 0 ? void 0 : value.name) === colorName;
                            });
                            // main continuous legend for d3 colors
                            if (isD3Colors && isD3Colors.discrete === false) {
                                arrayData_1 = [];
                                d3ColorArrays_1 = colorsArray(colorName, d3ColorScales);
                                data = range(10).map(function (d) { return ({ color: d3ColorArrays_1(d / 10) }); });
                                data.forEach(function (colorsObject, index) {
                                    var _a, _b, _c;
                                    arrayData_1.push([
                                        0 + "." + index,
                                        (_a = color(colorsObject.color)) === null || _a === void 0 ? void 0 : _a.rgb().r,
                                        (_b = color(colorsObject.color)) === null || _b === void 0 ? void 0 : _b.rgb().g,
                                        (_c = color(colorsObject.color)) === null || _c === void 0 ? void 0 : _c.rgb().b,
                                    ]);
                                });
                                legendColors = arrayData_1;
                            }
                            getColorTableScale_1 = (_a = (typeof colorTables === "string" ? parsedColorTables : colorTables)) === null || _a === void 0 ? void 0 : _a.find(function (value) {
                                if (getColorScaleData) {
                                    return value.name === (getColorScaleData === null || getColorScaleData === void 0 ? void 0 : getColorScaleData.name);
                                }
                                else {
                                    return value.name === colorName;
                                }
                            });
                            maxValue_1 = legendColors.length - 1;
                            // condition for nearest interpolation
                            if (isNearest) {
                                nColors = legendColors.length;
                                delta_1 = 1 / nColors;
                                leftEnd_1 = 0;
                                rightEnd_1 = 0 + delta_1;
                                legendColors.forEach(function (val) {
                                    nearestData_1.push({
                                        breakPoint: Number(leftEnd_1.toFixed(2)),
                                        color: RGBToHex([val[0], val[1], val[2], val[3]]).color,
                                    }, {
                                        breakPoint: Number(rightEnd_1.toFixed(2)),
                                        color: RGBToHex([val[0], val[1], val[2], val[3]]).color,
                                    });
                                    leftEnd_1 += delta_1;
                                    rightEnd_1 += delta_1;
                                });
                            }
                            // if colorMapFunction prop is passed
                            if (colorMapFunction) {
                                rgbValue = [];
                                for (i = 0; i <= 1; i += 0.05) {
                                    value = colorMapFunction(i);
                                    rgbValue.push([i.toFixed(2), value[0], value[1], value[2]]);
                                }
                                legendColors = rgbValue;
                            }
                            arrOfNum = breakPoint === null || breakPoint === void 0 ? void 0 : breakPoint.map(function (str) {
                                return Number(str);
                            });
                            userDefinedDomain_1 = arrOfNum ? arrOfNum : [];
                            legendColors.forEach(function (value, index) {
                                var domainIndex;
                                if (userDefinedDomain_1[index]) {
                                    domainIndex = userDefinedDomain_1[index];
                                }
                                else {
                                    domainIndex = value[0];
                                }
                                // return the color and breakPoint needed to draw the legend
                                itemColor.push({
                                    // to support discrete color for continous data
                                    breakPoint: (getColorTableScale_1 === null || getColorTableScale_1 === void 0 ? void 0 : getColorTableScale_1.discrete) === true
                                        ? RGBToHex(value, maxValue_1).offset
                                        : (breakPoint === null || breakPoint === void 0 ? void 0 : breakPoint.length) > 0
                                            ? domainIndex * 100.0
                                            : value[0] * 100.0,
                                    color: RGBToHex(value).color,
                                });
                            });
                            if (legendColors.length === 0) {
                                return [2 /*return*/, [0, 0, 0]];
                            }
                            // get the position and color from the breakpoint modal
                            // updates main legend onclicking the custom scales
                            if (((_b = editedBreakPointValues === null || editedBreakPointValues === void 0 ? void 0 : editedBreakPointValues.colorArray) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                                (editedBreakPointValues === null || editedBreakPointValues === void 0 ? void 0 : editedBreakPointValues.customizeFlag) === true) {
                                options = editedBreakPointValues.colorArray.map(function (row) {
                                    return { breakPoint: row.position * 100.0, color: row.color };
                                });
                                itemColor = options;
                            }
                            itemColor.sort(function (a, b) {
                                return a.breakPoint - b.breakPoint;
                            });
                            svgLegend = select(divRef.current)
                                .style("margin-right", "2px")
                                .style("margin-left", "2px")
                                .append("svg")
                                .style("cursor", getColorScaleData ? "pointer" : "auto")
                                .style("border-radius", "5px");
                            defs = svgLegend.append("defs");
                            svgLegend
                                .attr("width", horizontal ? (legendScaleSize < 200 ? 200 : legendScaleSize) : "100")
                                .attr("height", horizontal
                                ? "70"
                                : legendScaleSize < 200
                                    ? 200
                                    : legendScaleSize - 17);
                            currentIndex = "linear-gradient-" + id + "0";
                            linearGradient = defs
                                .append("linearGradient")
                                .attr("id", currentIndex);
                            // append a linearGradient element to the defs and give it a unique id
                            if ((horizontal && !reverseRange) || (!horizontal && reverseRange)) {
                                linearGradient
                                    .attr("x1", "0%")
                                    .attr("x2", horizontal ? "100%" : "0%")
                                    .attr("y1", "0%")
                                    .attr("y2", horizontal ? "0%" : "100%");
                            }
                            else if ((!horizontal && !reverseRange) ||
                                (horizontal && reverseRange)) {
                                linearGradient
                                    .attr("x1", horizontal ? "100%" : "0%")
                                    .attr("x2", "0%")
                                    .attr("y1", horizontal ? "0%" : "100%")
                                    .attr("y2", "0%");
                            }
                            colorScale_1 = scaleLinear().domain([0, 1]).range([0, 400]);
                            // append multiple color stops by using D3's data/enter step
                            linearGradient
                                .selectAll("stop")
                                .data(nearestData_1.length > 0 ? nearestData_1 : itemColor)
                                .enter()
                                .append("stop")
                                .attr("offset", function (data) {
                                return nearestData_1.length > 0
                                    ? colorScale_1(data.breakPoint) / 4 + "%"
                                    : data.breakPoint + "%";
                            })
                                .attr("stop-color", function (data) {
                                return data.color;
                            });
                            // draw the rectangle and fill with gradient
                            svgLegend
                                .append("rect")
                                .attr("x", 25)
                                .attr("y", horizontal ? 30 : 18)
                                .attr("width", horizontal
                                ? legendScaleSize < 200
                                    ? 159
                                    : legendScaleSize - 40
                                : 20)
                                .attr("height", horizontal ? 20 : legendScaleSize < 200 ? 159 : legendScaleSize - 40)
                                .style("fill", "url(#" + currentIndex + ")");
                            // append title
                            svgLegend
                                .append("text")
                                .attr("x", horizontal ? 25 : -168)
                                .attr("y", horizontal ? 20 : 15)
                                .style("text-anchor", "left")
                                .style("transform", horizontal ? "none" : "left")
                                .style("transform", horizontal ? "none" : "rotate(270deg)")
                                .style("fill", "grey")
                                .style("font-size", legendFontSize && legendFontSize > 0
                                ? "".concat(legendFontSize, "px")
                                : "16px")
                                .text(dataObjectName);
                            xLeg = (isLog ? scaleSymlog() : scaleLinear())
                                .domain(reverseRange ? [max, min] : [min, max])
                                /*@ts-ignore*/
                                .range([10, legendScaleSize < 200 ? 168 : legendScaleSize - 32]);
                            yLeg = (isLog ? scaleSymlog() : scaleLinear())
                                .domain(reverseRange ? [min, max] : [max, min])
                                /*@ts-ignore*/
                                .range([10, legendScaleSize < 200 ? 168 : legendScaleSize - 32]);
                            horizontalAxisLeg = axisBottom(xLeg).tickValues(xLeg
                                .ticks(0)
                                .concat(xLeg.domain(), getTickValues(xLeg.domain(), numberOfTicks)));
                            VerticalAxisLeg = axisRight(yLeg).tickValues(yLeg
                                .ticks(0)
                                .concat(yLeg.domain(), getTickValues(xLeg.domain(), numberOfTicks)));
                            if (isRangeShown) {
                                svgLegend
                                    .attr("class", "axis")
                                    .append("g")
                                    .attr("transform", horizontal ? "translate(16, 50)" : "translate(45, 7.5)")
                                    .style("font-size", tickFontSize && tickFontSize > 0 ? "".concat(tickFontSize, "px") : "12px")
                                    .style("font-weight", "700")
                                    .call(horizontal ? horizontalAxisLeg : VerticalAxisLeg)
                                    .style("height", 15);
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            error_1 = _c.sent();
                            console.error(error_1);
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        min,
        max,
        colorName,
        colorTables,
        horizontal,
        getColorScaleData,
        colorMapFunction,
        dataObjectName,
        id,
        reverseRange,
        isLog,
        isNearest,
        isRangeShown,
        legendFontSize,
        tickFontSize,
        numberOfTicks,
        legendScaleSize,
    ]);
    return (React.createElement("div", { style: __assign({ position: "absolute", minHeight: "70px", zIndex: 999, margin: "10px" }, cssLegendStyles) },
        React.createElement("div", { id: id ? id : "cont-legend - ".concat(generateUniqueId), ref: divRef })));
};
//# sourceMappingURL=ContinuousLegend.js.map